interface DifficultyBadgeProps {
  difficulty: "EASY" | "MEDIUM" | "HARD" | "INSANE";
}

const STYLES: Record<
  DifficultyBadgeProps["difficulty"],
  { label: string; classes: string }
> = {
  EASY: {
    label: "Easy",
    classes:
      "text-ds-success bg-ds-success/10 border-ds-success/20",
  },
  MEDIUM: {
    label: "Medium",
    classes:
      "text-ds-warning bg-ds-warning/10 border-ds-warning/20",
  },
  HARD: {
    label: "Hard",
    classes:
      "text-ds-coral bg-ds-coral/10 border-ds-coral/20",
  },
  INSANE: {
    label: "Insane",
    classes:
      "text-ds-danger bg-ds-danger/10 border-ds-danger/20 animate-pulse",
  },
};

export default function DifficultyBadge({ difficulty }: DifficultyBadgeProps) {
  const style = STYLES[difficulty];

  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 font-mono text-xs font-medium leading-5 ${style.classes}`}
    >
      {style.label}
    </span>
  );
}
